import { browser } from "$app/environment";

/**
 * Read a cookie value by name. Returns null on the server or if the cookie is absent.
 *
 * Note: values are returned raw (no decodeURIComponent). This is fine for
 * hex-string cookies like `hubspotutk` but may need extending if reused for
 * cookies whose values contain encoded characters.
 */
export function getCookie(name: string): string | null {
    if (!browser) return null;
    for (const pair of document.cookie.split(";")) {
        const [key, ...rest] = pair.trim().split("=");
        if (key === name) return rest.join("=") || null;
    }
    return null;
}
